module.exports = __webpack_public_path__ + "static/img/A-TFapple.2ac2b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-TFapple.png
// module id = kQuw
// module chunks = 3